import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-725becba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal" }
const _hoisted_2 = { class: "modal__body" }
const _hoisted_3 = { class: "modal__header" }
const _hoisted_4 = { class: "mb-1" }
const _hoisted_5 = { class: "mb-0" }
const _hoisted_6 = { class: "modal__content" }
const _hoisted_7 = { class: "text-muted" }
const _hoisted_8 = { class: "form-group required-field" }
const _hoisted_9 = { class: "form-input" }
const _hoisted_10 = { class: "form-group required-field" }
const _hoisted_11 = { class: "form-input" }
const _hoisted_12 = { class: "form-group mb-0 required-field" }
const _hoisted_13 = { class: "form-input" }
const _hoisted_14 = {
  key: 0,
  class: "error"
}
const _hoisted_15 = { class: "modal__footer" }
const _hoisted_16 = ["disabled"]

import { ref } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as yup from 'yup';
import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';
import useLocale from '@/util/locale';
import useApi from '@/services/api';
import Spinner from '@/components/_shared/Spinner/Spinner.vue';
import Icon from '@/components/_shared/Icon/Icon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SupplierModal',
  emits: ['onClose', 'onSubmit'],
  setup(__props, { emit: __emit }) {

const { persistForm, persisting } = useApi();
const { i18n } = useLocale();

const emits = __emit;

const formSchema = yup.object({
	name: yup
		.string()
		.required()
		.label(i18n.global.t('modals.name')),
	mobileNumber: yup
		.string()
		.required()
		.label(i18n.global.t('modals.mobileNumber')),
	nameOfShop: yup
		.string()
		.required()
		.label(i18n.global.t('modals.nameOfShop'))
});

const phoneNumber = ref();
const isPhoneValid = ref(false);
const phoneNumberMaxLength = ref(13);

const validateMobileNumber = e => {
	if (e.valid || !e.number) {
		phoneNumber.value = e.formatted;
	} else {
		phoneNumber.value = e.number;
	}

	if (e.formatted.startsWith('0')) {
		phoneNumberMaxLength.value = 14;
	} else {
		phoneNumberMaxLength.value = 13;
	}

	isPhoneValid.value = !!e.valid;
};

const onSubmit = values => {
	if (!isPhoneValid.value) return;
	const payload = {
		type: 'retail',
		first_name: values.name,
		phone_number: values.mobileNumber.replaceAll(' ', ''),
		retail_name: values.nameOfShop,
		email: 'N/A',
		last_name: 'N/A',
		text_message: 'N/A',
		store_number: 'N/A'
	};
	persistForm(payload).then(() => emits('onSubmit'));
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: "modal__overlay",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('onClose')))
    }),
    _createElementVNode("div", _hoisted_2, [
      (_unref(persisting))
        ? (_openBlock(), _createBlock(Spinner, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_unref(Form), {
        onSubmit: onSubmit,
        "validation-schema": _unref(formSchema)
      }, {
        default: _withCtx(({ meta }) => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.$t('modals.title')), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('modals.subTitle')), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('modals.formTitle')), 1),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('modals.name')), 1),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_unref(Field), { name: "name" }, {
                  default: _withCtx(({ field, meta }) => [
                    _createElementVNode("input", _mergeProps(field, {
                      type: "text",
                      class: "w-100"
                    }), null, 16),
                    (meta.valid)
                      ? (_openBlock(), _createBlock(Icon, {
                          key: 0,
                          icon: "check",
                          class: "valid"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createVNode(_unref(ErrorMessage), {
                name: "name",
                class: "error",
                as: "span"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('errors.nameIsRequired')), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('modals.nameOfShop')), 1),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_unref(Field), { name: "nameOfShop" }, {
                  default: _withCtx(({ field, meta }) => [
                    _createElementVNode("input", _mergeProps(field, {
                      type: "text",
                      class: "w-100"
                    }), null, 16),
                    (meta.valid)
                      ? (_openBlock(), _createBlock(Icon, {
                          key: 0,
                          icon: "check",
                          class: "valid"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createVNode(_unref(ErrorMessage), {
                name: "nameOfShop",
                class: "error",
                as: "span"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('errors.companyNameIsRequired')), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('modals.mobileNumber')), 1),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_unref(Field), {
                  name: "mobileNumber",
                  type: "number"
                }, {
                  default: _withCtx(({ field, errorMessage, meta }) => [
                    _createVNode(_unref(VueTelInput), _mergeProps({
                      modelValue: phoneNumber.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((phoneNumber).value = $event))
                    }, field, {
                      mode: "international",
                      "valid-characters-only": "",
                      "dynamic-placeholder": "",
                      "default-country": "SA",
                      "auto-default-country": false,
                      "dropdown-options": {
										showDialCodeInList: false,
										showDialCodeInSelection: false,
										showFlags: true
									},
                      "input-options": {
										name: 'mobileNumber',
										styleClasses: ['w-100'],
										showDialCode: true,
										maxlength: phoneNumberMaxLength.value
									},
                      onValidate: validateMobileNumber
                    }), null, 16, ["modelValue", "input-options"]),
                    ((errorMessage || !isPhoneValid.value) && meta.touched)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$t('errors.mobileNumberIsRequired')), 1))
                      : _createCommentVNode("", true),
                    (meta.valid && isPhoneValid.value)
                      ? (_openBlock(), _createBlock(Icon, {
                          key: 1,
                          icon: "check",
                          class: "valid always-right"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              class: "primary w-100 mb-1",
              disabled: !meta.valid || !isPhoneValid.value
            }, _toDisplayString(_ctx.$t('modals.send')), 9, _hoisted_16),
            _createElementVNode("button", {
              class: "no-style w-100",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (emits('onClose')))
            }, _toDisplayString(_ctx.$t('modals.close')), 1)
          ])
        ]),
        _: 1
      }, 8, ["validation-schema"])
    ])
  ]))
}
}

})